import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getOrderList({
    courier = '',
    endDate = '',
    limit,
    page,
    q,
    sort = '',
    startDate = '',
    status = '',
    statuses,
  }) {
    const params = {
      courier_id: courier,
      cursor: page,
      end_date: endDate,
      limit,
      q,
      sort_by: sort,
      start_date: startDate,
      status,
      statuses,
    };
    if (params.status === 'nearly_expired') {
      params.status = 'due_soon';
    }
    const url = '/rent_orders';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getCustomerOrders(page, limit, userId) {
    const params = {
      cursor: page,
      limit,
      user_id: userId,
    };
    const url = '/rent_orders';
    return api.get(url, { params });
  },
  getOrderDetail(id) {
    return api.get(`/rent_orders/${id}`);
  },
  getRentDurations({ status = '' } = {}) {
    const params = { status };
    return api.get(`/rent_durations`, { params: omitBy(params, isNil) });
  },
  setOrderLate(id) {
    return api.post(`/rent_orders/${id}/mark_late`);
  },
  getRentDurationDetail(id) {
    return api.get(`/rent_durations/${id}`);
  },
  createRentDuration(payload) {
    return api.post(`/rent_durations`, payload);
  },
  updateRentDuration(id, payload) {
    return api.put(`/rent_durations/${id}`, payload);
  },
  deactivateRentDuration(id) {
    return api.delete(`/rent_durations/${id}`);
  },
  reactivateRentDuration(id) {
    return api.put(`/rent_durations/${id}/reactivate`);
  },
  deleteRentDuration(id) {
    return api.delete(`/rent_durations/${id}/delete`);
  },
  getBlackoutDate(page) {
    const params = { cursor: page };
    const url = '/blackout_dates';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  setBlackoutDate(payload) {
    return api.post(`/blackout_dates`, payload);
  },
  deleteBlackoutDate(id) {
    return api.delete(`/blackout_dates/${id}/delete`);
  },
  getRentPageBanner() {
    return api.get(`/rent_pages`);
  },

  sentToInspection(orderId) {
    return api.post(`/rent_orders/${orderId}/finish`);
  },

  processRefund(orderId) {
    return api.post(`/rent_orders/${orderId}/refund_rent`);
  },

  /**
   * @typedef {Object} Payload
   * @property {(string)} image - Indicates whether the Courage component is present.
   * @property {String} banner_image - Indicates whether the Power component is present.
   * @property {String} slug - Indicates whether the Wisdom component is present.
   * @property {String} mobile_image - Indicates whether the Wisdom component is present.
   * @property {boolean} show_in_home - Indicates whether the Wisdom component is present.
   */
  /**
   * @param {Payload} payload - payload for updating rent banner
   */
  updateRentPageBanner(payload) {
    return api.put(`/rent_pages`, payload);
  },
};
